// extracted by mini-css-extract-plugin
export var attribution = "_d5-4";
export var authorName = "_d5-5";
export var quote = "_d5-3";
export var testimonial = "_d5-2";
export var trustedBy = "_d5-0";
export var trustedByLabel = "_d5-1";